import React, { useEffect } from "react";
import useGlobalPrivacyControl from "Hooks/useGlobalPrivacyControl";
import getClientSideQueryParam from "../../../Utilities/UrlUtilities/getClientSideQueryParam";
import SetCookie from "../../../Utilities/CookieUtilties/SetCookie";
import Script from "next/script";

function setGclidCookie(gclid) {
  SetCookie("smi-gclid-v2", gclid, 90);
}

export default function GoogleAds() {
  const { isGpcEnabled } = useGlobalPrivacyControl();

  useEffect(() => {
    const gclid = getClientSideQueryParam("gclid");

    if (!gclid || isGpcEnabled) {
      return;
    } else {
      setGclidCookie(gclid);
    }
  }, [isGpcEnabled]);

  console.log("GoogleAds boolean", !isGpcEnabled);

  if (!isGpcEnabled) {
    return (
      <>
        <Script
          id="gads-script"
          data-testid="gads-script"
          src={`https://www.googletagmanager.com/gtag/js?id=AW-1061040585`}
          strategy="afterInteractive"
        />
        <Script id="googleAds-script-config" strategy="afterInteractive">
          {`
            window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); }
            window.gtag('js', new Date());
            window.gtag('config', 'AW-1061040585', {
                'linker': {
                    'domains': ['app.maker.co']
                },
                'groups': ['ads']
            });
          `}
        </Script>
      </>
    );
  }

  return false;
}
